import { useAudioGraphStore } from './useAudioGraphStore';

export const useAudioSystem = () => {
  const isReady = useAudioGraphStore((state) => state.isReady);
  const errors = useAudioGraphStore((state) => state.errors);
  const start = useAudioGraphStore((state) => state.startTask);
  const rebuildGraph = useAudioGraphStore((state) => state.rebuildGraphTask);

  return {
    isReady,
    errors,
    start,
    rebuildGraph,
  };
};
